import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Tab,
  Tabs,
} from "@mui/material";
import TitleWithBack from "../Home/TitleWithBack";
import Loader from "../../Components/Loader";
import { VM_Colors } from "../../Styles/VMStyles";
import CheckList from "../../DashBoard/Configurations/CheckList";
import Permissions from "./Permissions/Permissions";
import FeedbackCategory from "./FeedbackCategory/FeedbackCategory";

function VMConfiguration() {
  const [state, setState] = useState({
    loading: false,
    activeTab: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleTabChange = (event, newValue) => {
    setState({ ...state, activeTab: newValue });
  };

  const tabStyle = {
    textTransform: "none",
    fontWeight: 500,
    borderRadius: 1,
    minWidth: 120,
    padding: "6px 12px",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease-in-out",
    fontSize: 14,
    color: VM_Colors.black,
    backgroundColor: VM_Colors.white1,
    borderLeft: "4px solid #E0E0E0", // light gray line when unselected
    "&.Mui-selected": {
      color: VM_Colors.white,
      backgroundColor: VM_Colors.primary,
      borderLeft: "none",
    },
    "&:hover": {
      backgroundColor: VM_Colors.primary,
      color: VM_Colors.white,
    },
  };

  return (
    <Paper sx={{ padding: 0.3 }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box p={2}>
          <TitleWithBack title="Configuration" />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Tabs
              value={state.activeTab}
              onChange={handleTabChange}
              variant="standard"
              TabIndicatorProps={{ style: { height: 3 } }}
              sx={{
                minHeight: "auto",
                "& .MuiTabs-flexContainer": {
                  flexWrap: "wrap",
                  gap: 1,
                },
              }}
            >
              <Tab label="Permissions" sx={tabStyle} />
              <Tab label="CheckList" sx={tabStyle} />
              <Tab label="Feedback Categories" sx={tabStyle} />
            </Tabs>
          </Box>
        </Box>

        <Box px={2} pb={2}>
          {state.activeTab === 0 && <Permissions />}
          {state.activeTab === 1 && <CheckList />}
          {state.activeTab === 2 && <FeedbackCategory />}
        </Box>

        <Loader loading={state.loading} />
      </Box>
    </Paper>
  );
}

export default VMConfiguration;
